import { makeVar, useReactiveVar } from '@apollo/client';

const isDevPanelOpened = makeVar<boolean>(false);

/**
 * Should be used only for tests purposes.
 */
export const UNSAFE_resetDevPanel = () => {
  isDevPanelOpened(false);
};

const toggleDevPanel = () => {
  isDevPanelOpened(!isDevPanelOpened());
};

const useDevPanel = () => {
  const reactiveIsDevPanelOpened = useReactiveVar(isDevPanelOpened);

  return {
    states: {
      isOpened: reactiveIsDevPanelOpened,
    },
    actions: {
      toggleDevPanel,
    },
  };
};

export default useDevPanel;
